import React, {Component} from 'react';
import assets from "../../../util/assets";
import {Col, Progress, Row,} from "reactstrap";
import "./index.css";
import "../common.css";
import {vuePayLog} from "../../../util/utility";
import {EmptyState, TipGoalContributors} from "./index";


export default class TipGoalComponent extends Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {

    }

    render() {
        const tipContributors = this.props.tipGoalData && this.props.tipGoalData.total_contributors;
        return (
            <div className="chat-component-container">
                <Row className="chat-component-header-container">
                    <Col className="chat-component-header">Like Goal</Col>
                    <Col className="chat-component-header-close">
                        <img src={assets.broadcast.cross}
                             onClick={() => {
                                 vuePayLog("TipGoalComponent", "", "Cross icon clicked");
                                 this.props.setRightLayout("");
                             }}
                             alt="cross icon"
                             width={13}/>
                    </Col>
                </Row>
                <div className="chat-component-header-divider "/>
                <div className="chat-component-main-content-container">
                    <div className="tip-goal-purpose">
                        <Row className="mt-1">
                            <Col md="12" sm="12">
                                <span className="bold-font">{this.props.tipGoalPurpose}</span>
                            </Col>
                        </Row>
                        <div className="chat-component-header-divider" style={{marginTop:16}}/>
                        <Row style={{marginTop:16}}>
                            <Col md="4">
                                <span className="bold-font">{this.props.tipGoalData.total_contributors}</span>
                            </Col>
                            <Col md="4">
                                <span className="bold-font">{this.props.tipGoalData.total_tip_amount_formatted}</span>
                            </Col>
                            <Col md="4">
                                <span className="bold-font">{this.props.tipGoalData.tip_goal_amount_formatted}</span>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="4">
                                <span className="normal-font">Contributions</span>
                            </Col>
                            <Col md="4">
                                <span className="normal-font">raised</span>
                            </Col>
                            <Col md="4">
                                <span className="normal-font">goal</span>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="11">
                                <div className="progressbarBackgroundColor">
                                    <Progress
                                        bar
                                        color="success"
                                        value={this.props.tipGoalData.percentage / 100 > 1 ? 100 : this.props.tipGoalData.percentage}
                                        style={{height: "10px", borderRadius: "2px"}}
                                    />
                                </div>
                            </Col>
                            <Col md="1" style={{marginLeft:-24}}>
                                <span className="normal-font">{this.props.tipGoalData.percentage}%</span>
                            </Col>
                        </Row>
                    </div>

                    <div>
                        <Row className="no-margin recent-tip-goal-contributors-container">
                            <Col md="12" sm="12" className="text-left px-0">
                                <p className="bold-font">
                                    Recent Like Goal Contributors({tipContributors})
                                </p>
                            </Col>
                        </Row>
                        {
                            this.props.tipGoalData.total_contributors > 0
                                ?
                                <TipGoalContributors tip={this.props.tip}/>
                                :
                                <EmptyState image={assets.tip_empty_state}/>
                        }
                    </div>
                </div>
            </div>
        )
    }
}


